import { render, staticRenderFns } from "./user_certiInfo.vue?vue&type=template&id=6e508494&scoped=true&"
import script from "./user_certiInfo.vue?vue&type=script&lang=js&"
export * from "./user_certiInfo.vue?vue&type=script&lang=js&"
import style0 from "./user_certiInfo.vue?vue&type=style&index=0&id=6e508494&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e508494",
  null
  
)

export default component.exports